import React, { useState } from 'react';
import { Button, Card, Col, Row, Space } from 'antd';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import isObject from 'lodash/isObject';
import { RiArrowLeftLine } from 'react-icons/ri';
import IntlMessages from '../../../../../../layout/components/lang/IntlMessages';
import handleResponse from '../../../../../../lib/handleResponse';
import transformErrors from '../../../../../../lib/transformErrors';
import BreadCrumbs from '../../../../../../layout/components/breadcrumbs';
import FormCreateEditPushNotificationSchedule from '../../../../forms/FormCreateEditPushNotificationSchedule';
import urlPagePushNotifications from '../../../../../../urls/urlPagePushNotifications';
import urlPagePushNotificationsSchedule from '../../../../../../urls/urlPagePushNotificationsSchedule';
import urlPagePushNotificationScheduleDetails from '../../../../../../urls/urlPagePushNotificationScheduleDetails';
import {
  useCreatePushNotificationScheduleMutation,
  useGetSpecificPushNotificationScheduleQuery,
} from '../../../../api/pushNotificationsScheduleApiSlice';



const PageCreatePushNotificationSchedule = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { scheduleId } = useParams();
  const [ formErrors, setFormErrors ] = useState({});

  const [ createPushNotificationSchedule, { isLoading: isCreatingPushNotificationSchedule } ] = useCreatePushNotificationScheduleMutation();

  const { data: schedule = {}, isLoading: isFetchingPushNotificationSchedule } = useGetSpecificPushNotificationScheduleQuery({ scheduleId }, { skip: !scheduleId });

  const initialValues = {
    push_notification_id: null,
    is_published: false,
    scheduled_at: null,
    use_utc_zero_time: false,
    min_version: null,
    max_version: null,
    platform: [],
    countries: [],
    languages: [],
  };

  const mergedInitialValues = {
    ...initialValues,
    ...schedule,
    push_notification_id: schedule?.push_notification?.data?.id ?? null,
    scheduled_at: null,
    is_published: false,
  };

  const onSubmit = (data) => {
    createPushNotificationSchedule(data)
      .unwrap()
      .then(() => {
        handleResponse(
          'success',
          intl,
          'ui-general-created-successfully',
          [ () => navigate(urlPagePushNotificationsSchedule()) ],
        );
      })
      .catch((error) => {
        handleResponse(
          'error',
          intl,
          'ui-general-create-failed',
          [ () => {
            if (isObject(error?.data?.errors)) {
              const formikInitialErrors = transformErrors(error?.data?.errors);

              setFormErrors(formikInitialErrors);
            }
          } ],
          error,
        );
      });
  };

  return (
    <>
      <Row
        gutter={[ 32, 32 ]}
        justify="space-between"
        className="hp-mb-32"
        align="middle"
      >
        <BreadCrumbs
          breadCrumbParent={
            <Link to={urlPagePushNotifications()}>
              <IntlMessages id='push-notifications-breadcrumbs' />
            </Link>
          }
          breadCrumbParent2={
            <Link to={urlPagePushNotificationsSchedule()}>
              <IntlMessages id='push-notifications-schedule-breadcrumbs' />
            </Link>
          }
          breadCrumbParent3={scheduleId ? (
            <Link to={urlPagePushNotificationScheduleDetails({ scheduleId })}>
              {scheduleId}
            </Link>) : null}
          breadCrumbActive={!scheduleId ? <IntlMessages id='ui-general-create' /> : <IntlMessages id='ui-general-clone' />}
        />

        <Col md={12} span={24}>
          <Row
            gutter={[ 8, 8 ]}
            justify="end"
            align="middle"
          >
            <Col>
              <Space>
                <Link to={urlPagePushNotificationsSchedule()}>
                  <Button
                    type="primary"
                    className="hp-mr-sm-8"
                    ghost="true"
                    icon={<RiArrowLeftLine className="hp-mr-8" size={18} />}
                  >
                    <IntlMessages id='ui-general-back-to-list' />
                  </Button>
                </Link>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[ 32, 32 ]}>
        <Col span={24}>
          <Card className="hp-border-color-black-40 hp-card-6">
            <FormCreateEditPushNotificationSchedule
              initialErrors={formErrors}
              initialValues={mergedInitialValues}
              isSubmitting={isCreatingPushNotificationSchedule || isFetchingPushNotificationSchedule}
              onSubmit={onSubmit}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PageCreatePushNotificationSchedule;
